import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const UtahMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg id='utah' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000' className='map'>
			<polygon
				id='UT_ZS'
				points='788.2 549.19 802.11 824.26 708.56 826.87 431.24 830.03 282.3 828.84 285.61 538.56 788.2 549.19'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'UT_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('UT_ZS')}
			/>
			<polygon
				id='UT_ZN'
				points='285.61 538.56 289.79 171.35 578.78 169.5 582.08 301.34 775.48 297.39 788.2 549.19 285.61 538.56'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'UT_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('UT_ZN')}
			/>
			<polygon
				points='499.16 328.81 499.27 333.13 503.82 333.13 499.34 335.8 499.44 340.13 496.57 337.45 492.09 340.13 494.79 335.8 491.91 333.13 496.46 333.13 499.16 328.81'
				className='shape'
			/>
			<rect x='503.76' y='335.06' width='162.35' height='20' fill='none' className='shape' />
			<path
				d='M504.76,349.6c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.03-2.07-1.12-3.22-2.41-3.22-4.15,0-2.9,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.31-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M525.97,352.1c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM527.26,341.98c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path d='M533.23,352.1l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M546.34,337.38l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M561.01,335.93h1.99l-2.76,14.45h6.53l-.33,1.73h-8.5l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M578.52,352.1c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM579.82,341.98c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M585.78,352.1l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.77,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M607.18,351.44c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM604.98,341.78c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M630.15,351.58c-.91.41-2.38.78-4.2.78-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.79,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M634.62,352.1l2.22-11.61h1.99l-2.22,11.61h-1.99ZM637.2,337.25c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M647.73,337.38l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M655.27,340.5l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.33.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='517 377.25 517.1 381.57 521.65 381.57 517.17 384.25 517.28 388.57 514.4 385.9 509.92 388.57 512.62 384.25 509.75 381.57 514.29 381.57 517 377.25'
				className='shape'
			/>
			<rect x='521.6' y='383.51' width='70.15' height='20' fill='none' className='shape' />
			<path
				d='M525.38,384.61c.91-.21,2.2-.35,3.5-.35,1.56,0,3.06.38,3.96,1.25.76.71,1.17,1.65,1.17,2.93,0,1.81-.89,3.33-1.94,4.21-1.25,1.05-3.08,1.55-4.9,1.55-.61,0-1.14-.04-1.65-.13l-1.23,6.48h-1.96l3.04-15.94ZM525.85,392.39c.56.12,1.02.16,1.61.16,2.73,0,4.56-1.7,4.56-3.97,0-1.93-1.37-2.69-3.22-2.69-.79,0-1.39.07-1.74.17l-1.21,6.33Z'
				className='shape'
			/>
			<path
				d='M536.61,400.55l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M557.66,393.5c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM548.73,395.97c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M563.89,388.94l1,6.61c.18,1.32.32,2.21.37,2.85h.07c.25-.62.56-1.38,1.24-2.7l3.54-6.76h2.18l-6.46,11.61h-1.96l-2.01-11.61h2.03Z'
				className='shape'
			/>
			<path
				d='M585.59,393.5c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM576.67,395.97c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='487.94 255.79 488.04 260.11 492.59 260.11 488.11 262.79 488.22 267.11 485.34 264.44 480.86 267.11 483.56 262.79 480.69 260.11 485.23 260.11 487.94 255.79'
				className='shape'
			/>
			<rect x='405.7' y='239.49' width='77.05' height='20' fill='none' className='shape' />
			<path
				d='M421.48,246.72c0,2.8-1.03,5.9-2.95,7.81-1.43,1.42-3.31,2.26-5.54,2.26-4.18,0-6.13-3.15-6.13-6.58,0-2.84,1.11-6,3.08-7.93,1.39-1.35,3.39-2.19,5.42-2.19,4.35,0,6.12,3.17,6.12,6.63ZM411.4,243.39c-1.56,1.56-2.46,4.4-2.46,6.66,0,2.63,1.17,5.06,4.33,5.06,1.38,0,2.69-.6,3.69-1.62,1.53-1.53,2.41-4.44,2.41-6.69s-.75-5.04-4.29-5.04c-1.44,0-2.7.63-3.7,1.62Z'
				className='shape'
			/>
			<path
				d='M425.27,259.17c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM434.19,246.65c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M452.51,239.49l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM449.17,246.74c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M463.56,255.87c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM461.36,246.21c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M468.49,256.53l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='348.16 790.91 348.27 795.23 352.82 795.23 348.34 797.91 348.44 802.23 345.57 799.56 341.09 802.23 343.79 797.91 340.91 795.23 345.46 795.23 348.16 790.91'
				className='shape'
			/>
			<rect x='352.76' y='771.79' width='122.67' height='20' fill='none' className='shape' />
			<path
				d='M353.76,786.33c.88.59,2.09,1.03,3.44,1.03,1.82,0,3.5-1.09,3.5-3.04,0-1.2-.68-2.1-2.37-3.02-2.07-1.12-3.22-2.41-3.22-4.15,0-2.89,2.49-4.75,5.46-4.75,1.58,0,2.76.46,3.31.84l-.71,1.63c-.51-.3-1.52-.77-2.81-.76-2,0-3.2,1.32-3.21,2.64,0,1.31.82,2.06,2.51,3,1.99,1.07,3.09,2.34,3.09,4.33,0,2.8-2.2,5-5.84,5-1.62,0-3.21-.53-3.89-1.12l.72-1.63Z'
				className='shape'
			/>
			<path
				d='M372.25,774.11l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M376.76,787.68c0-.89.63-1.61,1.51-1.61.82,0,1.34.61,1.34,1.44,0,.88-.62,1.58-1.52,1.58-.8,0-1.33-.62-1.33-1.41Z'
				className='shape'
			/>
			<path
				d='M403.19,788.14c-.94.37-2.66.85-4.56.85-2.28,0-4.06-.65-5.29-2.01-1.23-1.35-1.63-3.12-1.63-4.72,0-2.68,1.09-5.49,3.16-7.36,1.73-1.52,4.06-2.4,6.65-2.4,1.99,0,3.33.45,3.82.74l-.66,1.68c-.82-.42-1.94-.7-3.4-.7-1.9,0-3.66.71-5.01,1.97-1.51,1.41-2.43,3.73-2.43,5.92,0,3.12,1.57,5.19,5.16,5.19.96,0,1.87-.2,2.46-.46l.92-4.83h-3.27l.31-1.63h5.23l-1.46,7.77Z'
				className='shape'
			/>
			<path
				d='M417.04,788.17c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM414.84,778.51c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M433.13,781.79c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM424.2,784.25c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M436.94,788.83l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M446.9,791.47c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM455.83,778.95c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M470.17,788.17c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM467.97,778.51c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<rect
				x='586.89'
				y='658.99'
				width='60.55'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M586.27,698.51l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M620.76,695.33c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='373.11'
				y='320.01'
				width='72.08'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M372.49,359.53l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M406.36,362.61l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
		</svg>
	);
};

UtahMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default UtahMap;
